<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Who will handle the onboarding of this client?</h1>
    <p>During the onboarding process, we will require information and data regarding the payroll.</p>
    <p>Our team can work directly with your end client or work with yourselves as an intermediary to capture this information.</p>

      <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="radio-label custom-check"><input type="radio" :value="true" v-model="formData.isOnboardingViaIntermediary">We will handle be handling the onboarding of this client<span class="radiomark"></span></label>
            <label class="radio-label custom-check"><input type="radio" :value="false" v-model="formData.isOnboardingViaIntermediary">We would like Qtac to work directly with our client to onboard<span class="radiomark"></span></label>
      </form>
    </div>
  </div>


</template>


<script setup>

import { ref } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object
})


const validateStep = () => {
  return true;
}



const executeStep = async () => {
  return true;
}


defineExpose({ validateStep, executeStep });

</script>